import { useEffect } from 'react'

import { Input } from '@skytech/ui'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { getClassifications } from '@/modules/ecom-policy/new/helpers'
import { useNewPolicyContext } from '@/modules/ecom-policy/new/index.context'

const StepName = () => {
  const newPolicy = useNewPolicyContext()
  const [descriptionInfo, setDescriptionInfo] = newPolicy.descriptionInfo
  const [name, setName] = newPolicy.selectedName

  const translate = useTranslation()
  const [selectedClassifications] = useNewPolicyContext().selectedClassifications

  useEffect(() => {
    if (descriptionInfo.isCustom) return

    const noClassificationsSelected =
      !selectedClassifications || selectedClassifications.length === 0

    // To reset the previously generated desc for a scenario of resigning from the classifications in the process
    if (descriptionInfo.description && noClassificationsSelected) {
      setDescriptionInfo({
        isCustom: false,
        description: '',
      })

      return
    }

    if (noClassificationsSelected) return

    const classifications = getClassifications(translate)
    const isAllChoice = selectedClassifications.includes('ALL')

    const classificationList = selectedClassifications.map(selectedClassification => {
      const label = classifications.find(
        classification => classification.symbol === selectedClassification
      )?.label

      return label
    })

    setDescriptionInfo({
      isCustom: false,
      description: isAllChoice ? translate('All products') : classificationList.join(', '),
    })
  }, [
    descriptionInfo.description,
    descriptionInfo.isCustom,
    selectedClassifications,
    setDescriptionInfo,
    translate,
  ])

  return (
    <div className="xxs:flex-wrap flex md:flex-nowrap">
      <div className="m-2">
        <Input
          id="name"
          value={name}
          label={<Translation id="Policy name" />}
          onChange={e => setName(e.target.value)}
        />
      </div>

      <div className="m-2">
        <Input
          className="sm:w-80 lg:w-[35rem] 2xl:w-[62rem]"
          id="description"
          value={descriptionInfo.description}
          label={<Translation id="Description" />}
          onChange={e => setDescriptionInfo({ description: e.target.value, isCustom: true })}
        />
      </div>
    </div>
  )
}

export default StepName
